import axios from "axios";

const API_BASE = "https://api.hr-ebnhaian.cloud/api/v1"; // عدّلها حسب السيرفر عندك

export const api = axios.create({
    baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token"); // أو حسب تخزينك
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
